/**
 * initDropdowns
 * ======================
 */
/**
 * Find the panel a label controls: by aria-controls where present, otherwise
 * the next sibling of the label or of its wrapping heading.
 * @param {HTMLElement} label
 * @returns {HTMLElement|null}
 */
const getDropdownBody = (label) => {
  const controls = label.getAttribute("aria-controls");
  if (controls) {
    const target = document.getElementById(controls);
    if (target) return target;
  }

  return label.nextElementSibling || label.parentElement.nextElementSibling;
};

const initDropdowns = () => {
  // Guard: if no dropdowns on page
  if(!document.querySelectorAll(".dropdown")) return;

  const dropdownLabel = document.querySelectorAll(".dropdown-label__wrapper");

  dropdownLabel.forEach(dropdownLabel => {
    dropdownLabel.addEventListener("click", () => {

      dropdownLabel.classList.toggle("is-dropdown-active");
      const dropdownBody = getDropdownBody(dropdownLabel);
      if (!dropdownBody) return;

      const isOpen = dropdownLabel.classList.contains("is-dropdown-active");

      // Keep the state exposed to assistive tech in step with the class.
      if (dropdownLabel.hasAttribute("aria-expanded")) {
        dropdownLabel.setAttribute("aria-expanded", isOpen ? "true" : "false");
      }

      if(isOpen) {
        dropdownBody.style.maxHeight = dropdownBody.scrollHeight + "px";
      }
      else {
        dropdownBody.style.maxHeight = 0;
      }
      
    });
  });
}

export default initDropdowns;